import React from 'react';
import '../pages/Page.css';

function PageLayout({ hero, children }) {
  return (
    <>
      {hero}
      <main className="page-main container py-5">{children}</main>
    </>
  );
}

export default PageLayout;
